export default __webpack_public_path__ + "static/media/clouds.c2a481e2.svg";